import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';

// The four handlers below used to reach the div through {...rest}, filled in by
// defaultProps. Destructuring them to give them default parameters takes them
// out of rest, so they have to be forwarded explicitly.
const ClickableDiv = React.forwardRef(
  (
    {
      children,
      className = '',
      onKeyDown = noop,
      onBlur = noop,
      onMouseEnter = noop,
      onMouseLeave = noop,
      ...rest
    },
    ref
  ) => (
    <div
      data-testid="clickable-div"
      className={`outline-hidden ${className}`}
      role="button"
      tabIndex={0}
      ref={ref}
      onKeyDown={onKeyDown}
      onBlur={onBlur}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
    >
      {children}
    </div>
  )
);

ClickableDiv.propTypes = {
  onClick: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func,
  onBlur: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

export default ClickableDiv;
